import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { fontText, StylesIndexInjections } from 'common-react';

interface LabelWithBarStyleProps {
  color: string | undefined;
  size: 'small' | 'big';
}

export default makeUiStyles((theme: Theme) => {
  const defaultColor = theme.color.charts.chartColor1;

  return createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
    },
    titleLabel: {
      color: theme.color.greys[60],
      marginBottom: 4,
      textTransform: 'unset',
      font: fontText('normal', theme.fontSize.s, 20),
    },
    textWithBar: {
      font: ({ size }: LabelWithBarStyleProps) =>
        size === 'big'
          ? fontText('normal', theme.fontSize.base, 24)
          : fontText('normal', theme.fontSize.s, 20),
      textTransform: 'capitalize',
      color: theme.color.greys[80],
      paddingLeft: 8,
      borderLeft: ({ color }: LabelWithBarStyleProps) => `4px solid ${color || defaultColor}`,
    },
  });
}, { name: 'LabelWithBar', index: StylesIndexInjections.UI_ATOMS });
